"use strict";

define('view/image.chooser',['underscore', 'backbone', 'marionette', 'handlebars', '../templates', 'backbone.radio', '../libs/paste.handler', 'FileAPI', 'uikit/mixins/component.mixin', 'uikit/collections/checkbox.group', 'uikit/elements/button', 'uikit/collections/form', 'uikit/elements/input'], function (_, Backbone, Mn, Handlebars, Templates, Radio, PasteHandler, FileAPI, ComponentMixin, CheckboxGroupView, ButtonView, FormView, InputView) {
  var channel = Radio.channel('global');
  var IS_CHROME = String(navigator.userAgent).toLowerCase().indexOf('chrome') !== -1;
  var ImageChooserView = Mn.ItemView.extend(ComponentMixin).extend({
    template: Templates.IRB['image.chooser'],
    options: {
      selectedItem: null
    },
    update: {
      selectedItem: false
    },
    ui: {
      pasteBox: '.paste-handler'
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.once('render', function () {
        this.listenTo(this.radioGroup, 'change:value', this.onRadioGroupChangeValue);
        this.onRadioGroupChangeValue();
      }, this);
      this.initalizeViews();
    },
    onChangeSelectedItem: function onChangeSelectedItem() {
      var modal = this.getOption('modal');
      if (this.selectedItem) {
        modal.actions.each(function (actionView) {
          actionView.disabled = false;
        });
      }
    },
    onPasteInputRender: function onPasteInputRender() {
      if (this.pasteHandler) {
        this.pasteHandler.destroy();
      }
      if (IS_CHROME) {
        this.pasteHandler = new PasteHandler(this.pasteInput.ui.input).on('paste:image', function (file) {
          this.pasteInput.icon = 'check green';
          this.pasteInput.placeholder = 'Paste Successful';
          this.selectedItem = file;
          this.pasteInput.error = false;
        }, this).on('paste:error', function () {
          this.pasteInput.placeholder = 'Paste Failed';
          this.pasteInput.error = true;
        }, this);
      }
    },
    onUploadButtonPress: function onUploadButtonPress() {
      var self = this;
      channel.request('file:chooser', {
        accept: ['.png', '.jpg', '.jpeg'],
        events: false,
        callback: function callback(files) {
          if (files.length > 0) {
            self.selectedItem = files[0];
            self.uploadInput.value = self.selectedItem.name;
          }
        }
      });
    },
    onWebLinkInputChangeValue: function onWebLinkInputChangeValue() {
      var value = this.webLinkInput.value;
      this.selectedItem = new Backbone.Model({
        link: value
      });
    },
    onRadioSelectClipboard: function onRadioSelectClipboard() {
      this.focusInput(this.pasteInput);
    },
    onRadioSelectWebUrl: function onRadioSelectWebUrl() {
      this.focusInput(this.webLinkInput);
    },
    focusInput: function focusInput(input) {
      _.defer(function () {
        input.focus();
      });
    },
    initalizeViews: function initalizeViews() {
      var form = new FormView(),
        radioGroup = new CheckboxGroupView({
          radio: true
        }),
        uploadInput = new InputView({
          buttonRight: false,
          fluid: true,
          readonly: true
        }),
        webLinkInput = new InputView({
          placeholder: '',
          fluid: true
        }),
        pasteInput = new InputView({
          placeholder: '',
          fluid: true
        }),
        uploadButton = new ButtonView({
          text: 'Choose File'
        });
      uploadInput.button = uploadButton;
      this.listenTo(uploadButton, 'press', this.onUploadButtonPress).listenTo(pasteInput, 'change:value', function () {
        pasteInput.value = '';
      });
      radioGroup.childBindings = {
        text: 'text'
      };
      form.addField({}, radioGroup);
      radioGroup.collection = new Backbone.Collection([{
        text: 'Upload',
        name: 'upload'
      }, {
        text: 'Web URL',
        name: 'webUrl'
      }]);
      if (IS_CHROME) {
        radioGroup.collection.add({
          text: 'Clipboard',
          name: 'clipboard'
        });
      }
      radioGroup.value = radioGroup.collection.at(0);
      this.radioGroup = radioGroup;
      this.uploadTypeForm = form;
      this.webLinkInput = webLinkInput;
      this.uploadInput = uploadInput;
      this.pasteInput = pasteInput;
    },
    onRadioGroupChangeValue: function onRadioGroupChangeValue() {
      var index = this.radioGroup.collection.indexOf(this.radioGroup.value);
      this.$('[data-index="' + index + '"]').show().siblings().hide();
      this.triggerMethod('radio:select:' + this.radioGroup.value.get('name'));
    },
    onDestroy: function onDestroy() {
      if (this.pasteHandler) {
        this.pasteHandler.destroy();
      }
    }
  });
  return ImageChooserView;
});

